import React from 'react';
import {
  coco,
  CHART_DASHBOARD_ARTIFACT_TYPE,
  isChartDashboardPayload,
} from '@cotera/api';
import type { CustomToolRenderer } from '@cotera/client/v0/chat/tool-renderers';
import { ChartDashboardSnippet } from '@cotera/client/v0/components/charts';
import { useArtifactPanel } from '@cotera/client/v0/chat/artifact-panel-context';
import { useArtifactInlineDisplayMode } from '@cotera/client/v0/chat/artifact-inline-dedupe-context';
import { ArtifactEditIndicator } from '@cotera/client/v0/chat/artifact-edit-indicator';
import { ToolPart } from '@cotera/sdk/core';

const { COCO_RENDER_CHART_DASHBOARD_TOOL_KEY } = coco;

export const ChartDashboardToolRenderer: CustomToolRenderer = ({ part }) => {
  const artifactPanel = useArtifactPanel();
  const displayMode = useArtifactInlineDisplayMode(part);
  const artifact = part.getArtifact();

  if (
    artifact === null ||
    !isChartDashboardPayload(artifact.data) ||
    displayMode === 'none'
  ) {
    return null;
  }

  const artifactId = artifact.artifactId ?? part.toolCallId;

  if (displayMode === 'edit') {
    return (
      <ArtifactEditIndicator
        artifactId={artifactId}
        artifactType={CHART_DASHBOARD_ARTIFACT_TYPE}
        payload={artifact.data}
      />
    );
  }

  return (
    <ChartDashboardSnippet
      payload={artifact.data}
      onOpen={
        artifactPanel !== null
          ? () => {
              artifactPanel.focusArtifact(artifactId);
            }
          : undefined
      }
    />
  );
};

export function isRenderChartDashboardToolPart(part: ToolPart): boolean {
  return part.toolKey().toString() === COCO_RENDER_CHART_DASHBOARD_TOOL_KEY;
}
